import { Flex, Card, Empty, Tag, Typography } from 'antd'
import { useEffect, useCallback, useMemo, useState } from 'react'
import dayjs from 'dayjs'

const formatStartDate = (date) => {
  if (!date) return null
  const d = dayjs(date)
  return d.isValid() ? d.format('YYYY-MM-DD') : null
}

export const CustomerOrderList = ({ dataSource, onClick }) => {

  const [clickedOrderSn, setClickedOrderSn] = useState(null)

  useEffect(() => {
    if (dataSource?.length > 0) {
      setClickedOrderSn(dataSource[0].order_sn)
    } else {
      setClickedOrderSn(null)
    }
  }, [dataSource])

  const handleCardClick = useCallback((item) => {
    setClickedOrderSn(item.order_sn)
    onClick?.(item)
  }, [onClick])

  const orderCards = useMemo(() => {
    if (!dataSource?.length) return null
    return dataSource.map((item) => {
      const isActive = clickedOrderSn === item.order_sn
      const orderStatus = item.order_status|| '无'
      const departureTime = formatStartDate(item.start_date) || '-'
      return (
        <Card
          key={item.order_sn}
          size="small"
          hoverable
          onClick={() => handleCardClick(item)}
          className={isActive ? 'border-primary' : ''}
        >
          <Flex vertical gap={4}>
            <Typography.Text strong={isActive}>{item.order_id}</Typography.Text>
            <Flex gap={8} align="center">
              <Tag color={'default'} className="m-0 text-xs">
                  {orderStatus}
                </Tag>
              🛫<Typography.Text type="secondary" className="text-xs">
                   {departureTime}
                </Typography.Text>
            </Flex>
          </Flex>
        </Card>
      )
    })
  }, [dataSource, clickedOrderSn, handleCardClick])

  return (
    <Flex gap="small" wrap className="py-2">
      {orderCards ?? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </Flex>
  )
}
